import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  useLazyCouponsListQuery,
  useLazyCouponsTransactionListQuery,
} from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";
import TopHeader from "../Dashoboard/TopHeader";
import CouponPages from "./CouponPage";
import CouponTransaction from "./CouponTransaction";

const CouponsList = () => {
  const dispatch = useDispatch();
  const [btn, setBtn] = useState(false);
  const [tab, setTab] = useState(1);
  const [CouponTransactionPage, setCouponTransactionPage] = useState(1);
  const [CouponPage, setCouponPage] = useState(1);
  const [searchCoupon, setSearchCoupon] = useState("");
  const [searchCouponTransaction, setSearchCouponTransaction] = useState("");
  const [rowCoupon, setRowCoupon] = useState(10);
  const [rowCouponTransaction, setRowCouponTransaction] = useState(10);
  const [listCoupon, setListCoupon] = useState([]);
  const [listResovle, setListResovle] = useState([]);
  const [CouponCount, setCouponCount] = useState(1);
  const [CouponTransactionCount, setCouponTransactionCount] = useState(1);
  const [paginationCoupon, setPagonationCoupon] = useState({});
  const [paginationCouponTransaction, setPagonationCouponTransaction] =
    useState({});

  // RTK QUERY
  const [couponsListApi] = useLazyCouponsListQuery();
  const [couponsTransactionListApi] = useLazyCouponsTransactionListQuery();

  const getCouponList = (search_, row_value) => {
    let params = `?page=${CouponPage}`;
    dispatch(saveLoader(true));

    if (search_) {
      params += `&search=${search_}`;
    }

    if (row_value) {
      params += `&row=${row_value}`;
    }

    setRowCoupon(row_value);
    setSearchCoupon(search_);
    couponsListApi(params)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setListCoupon(res?.coupons);
        setCouponCount(
          Math.ceil(res?.pagination?.total / res?.pagination?.per_page)
        );
        setPagonationCoupon(res?.pagination);
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  const getCouponTransactionList = (search_, row_value) => {
    let params = `?page=${CouponTransactionPage}`;

    if (search_) {
      params += `&search=${search_}`;
    }

    if (row_value) {
      params += `&row=${row_value}`;
    }

    setRowCouponTransaction(row_value);
    setSearchCouponTransaction(search_);
    dispatch(saveLoader(true));
    couponsTransactionListApi(params)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setListResovle(res?.coupon_bookings);
        setCouponTransactionCount(
          Math.ceil(res?.pagination?.total / res?.pagination?.per_page)
        );
        setPagonationCouponTransaction(res?.pagination);
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  useEffect(() => {
    getCouponList(searchCoupon, rowCoupon);
  }, [CouponPage]);

  useEffect(() => {
    getCouponTransactionList(searchCouponTransaction, rowCouponTransaction);
  }, [CouponTransactionPage]);

  return (
    <div className="dashRightView home_section">
      <TopHeader type={"coupon-list"} />
      <div className=" block block-rounded ">
        <div className="block-content">
          <div className="nav-user mb-4" style={{ overflow: "auto" }}>
            <div className="presentation">
              <button
                className={`nav-presentation text-nowrap  ${
                  tab == 1 ? "pre-active" : ""
                }`}
                onClick={() => setTab(1)}
              >
                Coupon
              </button>
            </div>

            <div className="presentation">
              <button
                className={`nav-presentation text-nowrap  ${
                  tab == 2 ? "pre-active" : ""
                }`}
                onClick={() => setTab(2)}
              >
                Coupon Transaction
              </button>
            </div>
          </div>
          <div>
            {tab == 1 && (
              <CouponPages
                getCouponList={getCouponList}
                searchCoupon={searchCoupon}
                setCouponPage={setCouponPage}
                getCouponTransactionList={getCouponTransactionList}
                CouponCount={CouponCount}
                listCoupon={listCoupon}
                paginationCoupon={paginationCoupon}
                rowCoupon={rowCoupon}
                type={"user"}
              />
            )}

            {tab == 2 && (
              <CouponTransaction
                getCouponTransactionList={getCouponTransactionList}
                searchCouponTransaction={searchCouponTransaction}
                setCouponTransactionPage={setCouponTransactionPage}
                CouponTransactionCount={CouponTransactionCount}
                listResovle={listResovle}
                paginationCouponTransaction={paginationCouponTransaction}
                rowCouponTransaction={rowCouponTransaction}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CouponsList;
